"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowHideInputDirective = void 0;
const core_1 = require("@angular/core");
let ShowHideInputDirective = class ShowHideInputDirective {
    constructor() {
        this.type = 'password';
    }
    changeType(type) {
        this.type = type;
    }
};
exports.ShowHideInputDirective = ShowHideInputDirective;
__decorate([
    (0, core_1.HostBinding)(),
    __metadata("design:type", String)
], ShowHideInputDirective.prototype, "type", void 0);
exports.ShowHideInputDirective = ShowHideInputDirective = __decorate([
    (0, core_1.Directive)({ selector: '[show-hide-input]'
    }),
    __metadata("design:paramtypes", [])
], ShowHideInputDirective);
//# sourceMappingURL=show-hide-input.directive.js.map